import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

/**
 * Функция отправки команды на управления контакторами
 */
const useGroupControl = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      if (data.isGroup) {
        return http.post(`/groups/${data.objectIds[0]}/commands/control`, data.command)
      } else {
        return http.post(`/cabinets/monitoring/control`, {
          ...data.command,
          object_ids: data.objectIds,
        })
      }
    },
  })

  const send = async (data: any) => {
    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.command_send'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    send,
  }
}

/**
 * Функция отправки команд на опрос шкафов
 */
const useGroupUpdate = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      if (data.isGroup) {
        return http.post(`/groups/${data.objectIds[0]}/commands/state`, data.command)
      } else {
        return http.post(`/cabinets/commands`, {
          type: 'state',
          object_ids: data.objectIds,
        })
      }
    },
  })

  const send = async (data: any) => {
    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.command_send'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    send,
  }
}

export { useGroupControl, useGroupUpdate }
